module.exports = __webpack_public_path__ + "static/media/bg5.c8f8891c.jpg";